// extracted by mini-css-extract-plugin
export default {"OrderRejectModal":"styles_OrderRejectModal__6tV2f","noteInput":"styles_noteInput__wAAhs"};